export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      Result: 'error',
      ErrCode: '1011',
      ErrInfo: 'ユーザーIDまたはパスワードが正しくありません'
    }
  }
}